module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"user_grade":"User Grade","author_grade":"Author Grade"}}')
  delete Component.options._Ctor
}
